export type TemporalUnit = 'Y' | 'M' | 'W' | 'D' | 'H' | 'm' | 's'
export const TEMPORAL_UNITS = ['Y', 'M', 'W', 'D', 'H', 'm', 's']
